(function () {
    'use strict';

    angular
        .module('app.core')
        .run(run);

    run.$inject = ['culture', 'cultureName', 'localStorageService', '$location'];
    function run(culture, cultureName, $localStorage, $location) {
        var search = $location.search();

        culture.set(cultureName.en_CA);

        if (search.storageType) {
            $localStorage.setStorageType(search.storageType);
        }
    }
})();